import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "action-button w-100s"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.otherCoverages)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.otherCoverages?.Retiree?.Show)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "btn btn-primary plan-modal",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.openModal('hw-retiree-payments-history', 'Payments History', 'plan-retiree')), ["prevent"]))
            }, " Retiree Payments History "))
          : _createCommentVNode("", true),
        (_ctx.otherCoverages.A.Show)
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              class: "btn btn-primary plan-modal",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.openModal('hw-plan-a-summary', 'Health & Welfare', 'plan-a-family', null, null, 'Plan A Summary', null, { FromDate: _ctx.otherCoverages.A.From })), ["prevent"]))
            }, " Plan A "))
          : _createCommentVNode("", true),
        (_ctx.otherCoverages.C.Show)
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              class: "btn btn-primary plan-modal",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.openModal('hw-plan-c-summary', 'Health & Welfare', 'plan-c-mrp active', null, null, 'Plan C Summary',  null, { FromDate: _ctx.otherCoverages.C.From, ToDate: _ctx.otherCoverages.C.To })), ["prevent"]))
            }, " Plan C "))
          : _createCommentVNode("", true),
        (_ctx.otherCoverages.RMRP.Show)
          ? (_openBlock(), _createElementBlock("a", {
              key: 3,
              class: "btn btn-primary plan-modal",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.openModal('hw-plan-rmrp-summary', 'Health & Welfare', 'plan-c-mrp active', null, null, 'Plan RMRP Summary', null, { FromDate: _ctx.otherCoverages.RMRP.From, ToDate: _ctx.otherCoverages.RMRP.To })), ["prevent"]))
            }, " Plan RMRP "))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}